import { createFileRoute } from '@tanstack/react-router';
import { useLoginAdminStore } from '@/features/login-admin/store';
import { RepresentanteListagem } from '@/features/painel-administrativo/representante/page/RepresentanteListagem';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/admin/_a/representante')({
    beforeLoad: () => {
        const tipo = useLoginAdminStore.getState().loginAdmin?.representante?.tipo;
        const isPrincipal = tipo === 'Principal';
        return validateRoute({
            condition: isPrincipal,
            fintech: true,
        });
    },
    component: RepresentanteListagem,
});
